import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
    path:'/news/index',
    component: () => import('@/views/news/index.vue'),
  },
  {
    path:'/news/detail',
    component: () => import('@/views/news/detail.vue'),
  },
  {
    path:'/company/index',
    component: () => import('@/views/company/index.vue'),
  },
  {
    path:'/company/leader',
    component: () => import('@/views/company/leader.vue'),
  },
  {
    path:'/feedback/index',
    component: () => import('@/views/feedback/index.vue'),
  },
  {
    path:'/search',
    component: () => import('@/views/search/index.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
